<ng-template #content><ng-content></ng-content></ng-template>

@if (selectedOption === 0) {
  <div>
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
}

<div (click)="selectOption(0)" class="row m-2 py-3 px-1 cursor-pointer"
  [ngClass]="selectedOption === 0 ? 'border-brand-thick' : 'border'">
  <div class="col-md-1 py-3 d-flex justify-content-center align-items-center">
    @if (selectedOption === 0) {
      <img class="pr-2" alt="" src="/assets/images/radio_chacked_icon.svg">
    } @else {
      <img class="pr-2" alt="" src="/assets/images/radio_empty_icon.svg">
    }
  </div>
  <div class="d-flex justify-content-center align-items-center col-md-1">
    <img alt="" src="/assets/images/wholesaler_icon.png">
  </div>
  <div class="col-md-10">
    <div class="font-size-m font-weight-600">
      <b>
        <ng-container i18n="@@app_copy_heading_option0">Copy to order at wholesaler</ng-container>
      </b>
    </div>
    <div class="font-size-xs mt-1">
      <ng-container i18n="@@app_copy_wholesaler_description">Transmission of the positions to Elektro-Material, Otto Fischer and Elektrogrosshandel.</ng-container>
    </div>
    <div class="text-color-light-grey font-size-xs mt-1">
      <ng-container i18n="@@app_copy_description_option0">Format: "E-No. \t Quantity" (tab space separated)</ng-container>
    </div>
  </div>
</div>

@if (selectedOption === 3) {
  <div>
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
}

<div (click)="selectOption(3)" class="row m-2 py-3 px-1 cursor-pointer"
  [ngClass]="selectedOption === 3 ? 'border-brand-thick' : 'border'">
  <div class="col-md-1 py-3 d-flex justify-content-center align-items-center">
    @if (selectedOption === 3) {
      <img class="pr-2" alt="" src="/assets/images/radio_chacked_icon.svg">
    } @else {
      <img class="pr-2" alt="" src="/assets/images/radio_empty_icon.svg">
    }
  </div>
  <div class="d-flex justify-content-center align-items-center col-md-1">
    <i class="icon60 se-icon-segment_retail" role="status" aria-hidden="true"></i>
  </div>
  <div class="col-md-10">
    <div class="font-size-m font-weight-600">
      <b>
        <ng-container i18n="@@app_copy_heading_option3">Direct transfer</ng-container>
      </b>
    </div>
    <div class="font-size-xs mt-1">
      <ng-container i18n="@@app_direct_transfer_description">Transferring items to Elektrogrosshandel.</ng-container>
    </div>
  </div>
</div>

@if (selectedOption === 1) {
  <div>
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
}

<div (click)="selectOption(1)">
  <div class="row m-2 py-3 px-1 cursor-pointer d-flex justify-content-center align-items-center"
    [ngClass]=" selectedOption === 1 ? 'border-brand-thick' : 'border'">
    <div class="float-left col-md-1 py-3">
      @if (selectedOption === 1) {
        <img class="pr-2" alt="" src="/assets/images/radio_chacked_icon.svg">
      } @else {
        <img class="pr-2" alt="" src="/assets/images/radio_empty_icon.svg">
      }
    </div>
    <div class="d-flex justify-content-center align-items-center col-md-1">
      <img alt="" src="/assets/images/CSV_file_icon.png">
    </div>
    <div class="float-left col-md-10">
      <div class="font-size-m font-weight-600">
        <b>
          <ng-container i18n="@@app_copy_heading_option1">Download .csv file</ng-container>
        </b>
      </div>
      <div class="font-size-xs mt-1">
        <ng-container i18n="@@app_copy_csv_description">Option to import the positions at any wholesaler.</ng-container>
      </div>
      <div class="text-color-light-grey font-size-xs mt-1">
        <ng-container i18n="@@app_copy_description_option1">Format: "E-No. Quantity</ng-container>
      </div>
    </div>
  </div>
</div>

@if (selectedOption === 2) {
  <div>
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
}

<div (click)="selectOption(2)">
  <div class="row m-2 py-3 px-1 cursor-pointer d-flex justify-content-center align-items-center"
    [ngClass]="selectedOption === 2 ? 'border-brand-thick' : 'border'">
    <div class="float-left col-md-1 py-3">
      @if (selectedOption === 2) {
        <img class="pr-2" alt="" src="/assets/images/radio_chacked_icon.svg">
      } @else {
        <img class="pr-2" alt="" src="/assets/images/radio_empty_icon.svg">
      }
    </div>
    <div class="d-flex justify-content-center align-items-center col-md-1">
      <img alt="" src="/assets/images/mySE_icon.png">
    </div>
    <div class="col-md-10">
      <div class="font-size-m font-weight-600">
        <b>
          <ng-container i18n="@@app_copy_heading_option2">Copy to order at mySchneider</ng-container>
        </b>
      </div>
      <div class="text-color-light-grey font-size-xs mt-1">
        <ng-container i18n="@@app_copy_description_option2">Format: "Reference-No.,,Quantity" (,, separated)</ng-container>
      </div>
    </div>
  </div>
</div>

